<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      title="问卷回复记录详情"
      width="500"
      @close="close"
    >
      <el-row>
        <el-col :span="5">回复人:</el-col>
        <el-col :span="19">
          <el-avatar shape="square" :size="32" :src="showForm.basic.profile.avatar"></el-avatar>
          <div>{{ showForm.basic.profile.name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">设备标题:</el-col>
        <el-col :span="19">{{ showForm.basic.deviceTitle }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">问卷标题:</el-col>
        <el-col :span="19"><el-tag>{{ typehoods.find(e => e.value == showForm.basic.questTypehood).label }}</el-tag> {{ showForm.basic.questTitle }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">回复:</el-col>
        <el-col :span="19">
          {{ showForm.basic.answerList.join('，') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">回复时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import typehoods from './typehood.config'
import { findQuestRecord } from '@/api/alfmeier'
export default {
  name: 'AlfmeierQuestRecordDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      typehoods,
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const questRecordId = row.questRecordId
      this.row = row
      const data = await findQuestRecord({
        questRecordId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
